module.exports = __webpack_public_path__ + "static/media/Arrow 1.5b003334.svg";